var map = {
	"./email.png": 959,
	"./laptop.png": 557,
	"./peopleAboutUs1.png": 711,
	"./peopleAboutUs2.png": 8,
	"./peopleAboutUs3.png": 510,
	"./phone.png": 862,
	"./project_img1.png": 527,
	"./project_img2.png": 109,
	"./project_img3.png": 831,
	"./whyRPAimg.png": 619
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 513;